export default __webpack_public_path__ + "static/media/host_reconnect_camera.59cd35e7.svg";